import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {NgIdleModule} from '@ng-idle/core';

import {ToastrModule} from 'ngx-toastr';
import {BreadcrumbsModule} from '../breadcrumb/breadcrumb.module';
import {HeaderModule} from '../header/header.module';
import {MenuModule} from '../menu/menu.module';
import {FullLayoutComponent} from './full-layout.component';
import {SimpleLayoutComponent} from './simple-layout.component';
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ToastrModule.forRoot({
      timeOut: 7000,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
    }),
    NgIdleModule.forRoot(),
    MenuModule,
    BreadcrumbsModule,
    HeaderModule,
  ],
  declarations: [FullLayoutComponent, SimpleLayoutComponent],
  exports: [FullLayoutComponent, SimpleLayoutComponent],
  providers: [],
})
export class LayoutModule {}
